import { useState,useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Box } from "@mui/system";
import { Table, Input, Dropdown, Menu, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { getPermissionCount } from "../../utility/permissions";
import { downloadRequest } from "../../../store/actions/roles";
import { DropdownFilterWithSearchAndCheckbox } from "../../../components/DropdownFilter";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button } from "@vds/buttons";
import CustomModal from "../../../components/CustomModal";
import {fetchRequest, setCurrentModal} from "../../../store/actions/roles"
import CreateRole from "../../../pages/Role/CreateRole";
import { DeleteRolesModal } from "../../../pages/Role/RolesModal";
import { deleteRoleEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import ToastNotification from "../ToastNotification";

const RolesTable = (props) => {
  const {  setSelectedRule, isEditable, isCreateUser, permissions, userRoleName,roleLists } = props;

  const [searchRoleName, setRoleName] = useState("");
  const roleList = useSelector((state) => state?.roles?.roles);
  const loading = useSelector((state) => state?.roles?.isLoading);
  const currentModal = useSelector((state) => state?.roles?.currentModal);
  const filters = useSelector((state) => state?.roles?.filters);
  const [isbulkPopupVisible, setIsBulkPopupVisible] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showDeleteRole, setShowDeleteRole] = useState(false);
  const [deleteRuleConfirmed, setDeleteRuleConfirmed] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [rolesval, setRoles] = useState(useSelector((state) => state?.roles?.roles));
  const [runEffectCount, setRunEffectCount] = useState(0);
  const [formData, setFormData] = useState({
    roleName: "",
    description: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const createuser = true;


  const editRole = (record) => {
    setSelectedRule(record);
    if (record) {
      setSelectedRole(record)
      setIsBulkPopupVisible(true)
    }
  };
  useEffect(() => {
    if (runEffectCount < 2) {
      setRoles(roleList);
      setRunEffectCount(runEffectCount + 1); 
    }
  }, [roleList]); 
  useEffect(() => {
    // dispatch(fetchRequest());
    setIsPopupVisible(false)
    setRoles(roleList)
  }, [isPopupVisible, rolesval]);
  
  const handleDownload = () => {
    try {
      dispatch(downloadRequest());
      setNotificationProps({
        type: 'success',
        message: 'Export',
        description: 'Export completed successfully.',
        duration: 1,
        style: { backgroundColor: '#d4edda', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } catch (error) {
      setNotificationProps({
        type: 'error',
        message: 'Export',
        description: error.message || 'Unable to serialize unrecognized input.',
        duration: 5,
        style: { backgroundColor: '#FFECE0', color: 'black' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 5000);
    }
  };
  const handleUserCreatedAdd = () => {
    dispatch(fetchRequest());
    setIsBulkPopupVisible(false);
  };
  const closebulkPopup = () => {
    setIsBulkPopupVisible(false);
    setSelectedRole(null)
  };
  const deleteRole = (record) => {
    setSelectedRole(record)
    setShowDeleteRole(true);
    dispatch(setCurrentModal(true))

  };
  const filteredData = roleList?.filter((item) => {
    const isRoleNameMatch =
      !searchRoleName ||
      item?.name?.toLowerCase().includes(searchRoleName.toLowerCase());
    return isRoleNameMatch;
  });

  let dummyData = [];
  const handleSearchRoleName = (e) => {
    let order = "desc";
    let field = "name";
    if (e.isAsc === true) {
      order = "asc";
      if (e.isAsc === false) {
        order = "desc";
      }
    }
    dispatch(
      fetchRequest({
        ...filters,
        sort: [
          {
            field,
            order,
          },
        ],
        name:  e.filteredResult.length > 0 ? e.filteredResult : [],
      })
    );
  };
  const handleRolesFilterReset = () => {
    dispatch(fetchRequest());
    setRoleName("");
    setTimeout(() => {
      setIsPopupVisible(true)
    }, 2000);
  };
  filteredData?.map((val) => {
    let isValidAction = true;
    if (userRoleName !== "SUPER_ADMIN") {
      isValidAction = val?.name !== "SUPER_ADMIN";
    }
    dummyData.push({
      key: val?.uid,
      roleEmail: val?.groupemail,
      name: val?.name,
      value: val,
      isValidAction,
      action: (
        <div style={{textAlign:"right"}}>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item>
                <ul
                  className="dropdown-menu text-capitalize show"
                  data-popper-placement="left-end"
                  style={{
                    position: "absolute",
                    inset: "auto 0px 0px auto",
                    margin: 0,
                    transform: "translate3d(-51px, -0.5px, 0px)",
                  }}
                >
                  <li className="dropdown-item">
                    <h6><Link
                      to="/users"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/users", {
                          state: {
                            roleId: val?.id,
                            name:val?.name
                          }
                        });
                      }}
                      className="breadcrums-item_link"
                    >
                      View role users
                    </Link></h6>
                  </li>
                  <li>
                    <h6 className="dropdown-header">ACTIONS</h6>
                  </li>
                  <li>
                    {isEditable && isValidAction ? <li className="dropdown-item" onClick={() => editRole(val)}>
                      <h6>Edit Role</h6>
                    </li> : <></>}
                    {isEditable && isValidAction ? <li className="dropdown-item" onClick={() => deleteRole(val)}>
                      <h6>Delete Role</h6>
                    </li> : <></>}
                    {isCreateUser ? <li className="dropdown-item">
                      <h6>
                        {" "}
                        <Link
                          to="/users"
                          state={{ createuser, role_Id: val?.id, }}
                          className="breadcrums-item_link"
                        >
                          Add User
                        </Link>
                      </h6>
                    </li> : <></>}
                  </li>
                </ul>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <button
            className="btn btn-link text-secondary"
            data-bs-toggle="dropdown"
            onClick={(e) => e.preventDefault()}
            data-testid="roles-menu-action"
          >
            <i className="bi-three-dots-vertical fs-6" />
          </button>
        </Dropdown>
        </div>
      ),
    });
  });

  const columns = [
    {
      title: (
        <div>
          <div
            className="input-group input-group-sm d-flex"
            data-controller="qrcode-reader"
            data-action="qrcode:scanned->form#submit"
          >
             <DropdownFilterWithSearchAndCheckbox
              text="Name"
              isSortable={true}
              onApply={handleSearchRoleName}
              onReset={handleRolesFilterReset}
              checkboxItems={
                roleList?.map((roles) => ({
                      text: roles?.name,
                      value: false,
                    }))
              }
            />
          </div>
        </div>
      ),
      dataIndex: "roleEmail",
      render: (text, record) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h6 style={{fontFamily:"VerizonNHGDSBold"}}>
                <button
                  className="custom-link"
                  onClick={() => isEditable && record?.isValidAction ? editRole(record?.value) : null}
                >
                  {record?.name?.toUpperCase()}
                </button>
              </h6>
              <p className="mb-0">{record?.value?.description}</p>
              <p className="mb-0">{`${getPermissionCount(record?.value?.permissions)} Permissions`}</p>
            </div>
          </div>
        );
      },
      SortOrder: "assend",
    },
    {
      title: permissions?.roles?.download ? (
        <div style={{textAlign:"right"}}>
        <Dropdown
        data-testid="download-dropdown"
        placement="left"
        overlayClassName="ats-filter-overlay"
        overlay={
          <Menu data-testid="download-dropdown-menu" style={{ width: "200px", padding: "10px" }}>
            <div style={{ maxHeight: "150px", overflowY: "auto", paddingRight: "5px" }}>
              <div style={{ paddingLeft: 10, marginTop: 3 }}>
                <span className="font-face-vzw">Action</span>
                <div style={{ marginTop: 6, marginBottom: 3, fontSize: 16, cursor: "pointer" }} onClick={handleDownload}>
                  <span>Export</span>
                </div>
              </div>
            </div>
            <Menu.Divider />
          </Menu>
         
        }
        trigger={["click"]}
      >
        <button
          data-testid="download-dropdown-btn"
          className="btn btn-link text-secondary"
          data-bs-toggle="dropdown"
          onClick={(e) => e.preventDefault()}
        >
          <i className="bi-three-dots-vertical fs-6" />
        </button>
      </Dropdown>
      </div>
      ) : null,
      dataIndex: "action",
    },
  ];
  const onConfirm = async () => {
    setDeleteRuleConfirmed(true);
    setShowDeleteRole(false);
    dispatch(setCurrentModal(false))
    const response = await fetch(deleteRoleEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        roleId: selectedRole?.id,
      }),
    });
    const responseJson = await response;
    const deleteRoleRsp = response;
    if (deleteRoleRsp) {
      if (deleteRoleRsp?.status===200||deleteRoleRsp?.status===204) {
        setFormData({
          roleName: "",
          description: ""
        });
        setNotificationProps({
          type: 'success',
          message: 'Delete Role',
          description: `Role "${selectedRole?.name}" deleted successfully`,
          duration: 1,
          style: { backgroundColor: '#d4edda', color: '#155724' },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
        handleUserCreatedAdd()
        setDeleteRuleConfirmed(false);
        setShowDeleteRole(false);
      }else if(deleteRoleRsp?.status===500 && deleteRoleRsp?.error === "conflict_error"){
        setNotificationProps({
          type: 'error',
          message: 'Delete Role',
          description: 'failed',
          duration: 1,
          style: { backgroundColor: '#FFECE0', color: '#155724' },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
        setDeleteRuleConfirmed(false);
        handleUserCreatedAdd();
        setShowDeleteRole(false);
      }else{
        setNotificationProps({
          type: 'error',
          message: 'Delete Role',
          description: 'failed',
          duration: 1,
          style: { backgroundColor: '#FFECE0', color: '#155724' },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
        handleUserCreatedAdd()
        setDeleteRuleConfirmed(false);
        setShowDeleteRole(false);
      }
    }
  };

  const onExit = () => {
    setDeleteRuleConfirmed(false);
    setShowDeleteRole(false);
    dispatch(setCurrentModal(false))

  };
  return (
    <>
      <Box
        sx={{
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
          borderTopWidth: 0,
        }}
      >
        {isbulkPopupVisible && (
          <CreateRole visible={isbulkPopupVisible} closePopup={closebulkPopup} state={selectedRole} onUserCreated={handleUserCreatedAdd} />
        )} 
         {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}
        <CustomModal popupName={''} customClass={'deleteAlertGroup'} popupTitle={'Delete Role'} open={currentModal}>
          <>
            <p style={{ padding: '5px', marginTop: '25px', paddingLeft: '0px' }}>Are you sure you’d like to delete the Role{" "} <span className="font-face-vzw">{selectedRole?.name} </span>?</p>
            <Grid2
              container
              marginTop={1}
              marginBottom={0}
              spacing={1}
              columns={{ xs: 12 }}
            >
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-cancel"
                    type="default"
                    shape="round"
                    style={{ fontWeight: "bold", width: "100%", backgroundColor: "white", color: "black", }}
                    onClick={() => onExit()}
                    size={"large"}
                  >
                    No, cancel
                  </Button>
                </div>
              </Grid2>
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <Button
                    className="custom-button-save"
                    type="primary"
                    shape="round"
                    onClick={() => {
                      onConfirm()
                    }}
                    style={{ fontWeight: "bold", width: "100%" }}
                    size={"large"}
                  >
                    Yes, delete
                  </Button>
                </div>
              </Grid2>
            </Grid2>
          </>
        </CustomModal>
        <Table data-testid="roles-table" style={{ marginTop: "24px" }} className="sasp_common-table" columns={columns} dataSource={dummyData}
        loading={loading}
          pagination={dummyData?.length > 50 && {
            total: dummyData?.length,
            showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total}`,
            position: ["bottomRight"],
            prevIcon: ['Prev'],
            nextIcon: ['Next'],
          }}
        />
      </Box>
    </>
  );
};

export default RolesTable;